import React, { useRef } from 'react';
import './logoUploader.css';

const LogoUploader = ({ onUpload, uploading, uploadError, profileImageUrl, imageError }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && onUpload) {
      onUpload(file);
    }
    // Reset input to allow selecting the same file again
    event.target.value = '';
  };

  return (
    <div className="logo-uploader_container">
      <label className="logo-uploader__title">Logo empresa:</label>
      
      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={uploading}
        className="logo-uploader__hidden-input"
        style={{ display: 'none' }}
      />
      
      {/* Custom styled button that looks like native file input */}
      <div className="logo-uploader__file-input-wrapper">
        <button
          type="button"
          onClick={handleButtonClick}
          disabled={uploading}
          className="logo-uploader__custom-button"
        >
          Seleccionar archivo
        </button>
        <span className="logo-uploader__file-text">
          {profileImageUrl ? 'Archivo seleccionado' : 'Ningún archivo seleccionado'}
        </span>
      </div>
      
      {uploading && <p className="logo-uploader__uploading">Subiendo...</p>}
      {uploadError && <p className="logo-uploader__error">{uploadError}</p>}
      {imageError && <p className="logo-uploader__error">{imageError}</p>}
      {profileImageUrl && (
        <img src={profileImageUrl} alt="Company Logo" className="logo-uploader__image-container" />
      )}
    </div>
  );
};

export default LogoUploader;
